import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { ListboxButton } from './listbox-button.component.js';
import { ListboxList } from './listbox-list.component.js';
import { ListboxPopover } from './listbox-popover.component.js';
import { Listbox } from './listbox.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const propTypes = {
  inModal: PropTypes.bool
};
const BasicListbox = renderWithRef('BasicListbox', propTypes, (props, ref) => {
  const {
      arrow = false,
      button,
      children,
      inModal = false,
      portal = true,
      darkMode,
      bgc,
      backgroundColor,
      'aria-label': ariaLabel
    } = props,
    otherProps = _objectWithoutProperties(props, ["arrow", "button", "children", "inModal", "portal", "darkMode", "bgc", "backgroundColor", 'aria-label']);
  const bgColor = bgc || backgroundColor;
  return /*#__PURE__*/React.createElement(Listbox, _extends({
    darkMode: darkMode,
    bgc: bgColor
  }, otherProps, {
    ref: ref
  }), _ref => {
    let {
      value,
      valueLabel
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListboxButton, {
      "aria-label": ariaLabel,
      arrow: arrow
    }, typeof button === 'function' ? button({
      value,
      label: valueLabel
    }) : button), /*#__PURE__*/React.createElement(ListboxPopover, {
      darkMode: darkMode,
      bgc: bgColor,
      portal: portal,
      inModal: inModal
    }, /*#__PURE__*/React.createElement(ListboxList, null, children)));
  });
});
export { BasicListbox };